import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Handles scroll position on every route change:
 * - If the URL has a hash (e.g. /#featured), scrolls to that section.
 * - Otherwise, snaps back to the top of the page.
 * Uses an instant jump so it doesn't fight the global smooth-scroll CSS.
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    const root = document.documentElement;

    if (hash) {
      const id = hash.replace('#', '');
      // Give the target page a tick to finish rendering before measuring.
      const timer = window.setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const previous = root.style.scrollBehavior;
          root.style.scrollBehavior = 'auto';
          const y = el.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: y });
          root.style.scrollBehavior = previous;
        }
      }, 60);
      return () => window.clearTimeout(timer);
    }

    const previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    root.style.scrollBehavior = previous;
  }, [pathname, hash, key]);

  return null;
}